<div class="d-flex flex-column justify-content-center">
    <p style="font-size: 12px;font-weight: 500;">
        On a scale of 1 to 5, 1 being the lowest, 5 being the best, how would you rate our service?
    </p>

        <button type="button" class="btn btn-outline-primary" *ngFor="let button of buttons; let i = index"
                (click)="setEduction(i)" style="margin-bottom: 10px;width: 95%;height: 40px;"
                [ngStyle]="{ 'background-color': buttons[i].isClickable ? '#FFFFFF' : '#E4E5E8' }">
            <div class="row">
                <div class="col-9">
                      <span [ngStyle]="{ 'color': buttons[i].isClickable ? '#182F7C' : '#333333' }"
                            style="color: #182F7C!important;font-size: 12px;">
                    {{buttons[i].title}}
                </span>
                </div>
                <div class="col-3">
                    <img src="assets/imgs/001-star%204.png"
                         height="16" width="16" style="margin-bottom: 10px"/>
                    <span style="color: rgba(51, 51, 51, 0.6);font-size: 22px;font-weight: bold;padding-left: 1px;">{{buttons[i].rate}}</span>
                </div>
            </div>
        </button>
    </div>

